import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getRplCTA = 'sertifikasi-rpl';
const getDetailRplCTA = 'sertifikasi-rpl/';
const postRplCtaUrl = 'sertifikasi-rpl';
const putRplCtaUrl = 'sertifikasi-rpl/';
const deleteRplCTA = 'sertifikasi-rpl/delete-sertifikasi-rpl/';

class RplCTAService {
    getRplCTA(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getRplCTA + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter + '&kategoriRpl=CTA',
            {
                headers: authHeader()
            });
    }
    getDetailRplCTA(formData) {
        return axios.get(
            API_URL + getDetailRplCTA + formData,
            {
                headers: authHeader()
            });
    }

    postRplCta(formData) {
        var form = new FormData();
        form.append("kodeRpl", formData.kodeRpl);
        form.append("namaRpl", formData.namaRpl);
        form.append("idLevel", formData.idLevel);
        form.append("biaya", formData.biaya);
        form.append("biayaMengulang", formData.biayaMengulang);
        form.append("tanggalDimulai", formData.tanggalDimulai);
        form.append("tanggalBerakhir", formData.tanggalBerakhir);
        form.append("lokasi", formData.lokasi);
        form.append("idKotaKab", formData.idKotaKab);
        form.append("kapasitas", formData.kapasitas);
        form.append("sisa", formData.kapasitas);
        form.append("idKategoriRpl", "840b7ca8-88bc-490e-862d-8c65e0e0f504");
        for (var i = 0; i < formData.inputs.length; i++) {
            form.append('instrukturSertifikasiRplRequest['+i+'].idInstrukturRpl', formData.inputs[i].idInstrukturRpl);
        }
        for (var j = 0; j < formData.upload_dok.length; j++) {
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].kodeDokumen', formData.upload_dok[j].kode_dokumen);
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].namaDokumen', formData.upload_dok[j].nama_dokumen);
            if (typeof formData.upload_dok[j].contoh_dokumen !== 'undefined') {
                form.append('dokumenPendukungSertifikasiRplRequest['+j+'].contohDokumen', formData.upload_dok[j].contoh_dokumen);
            }
        }
        for (var k = 0; k < formData.mata_ujian.length; k++) {
            form.append('sertifikasiRplMataUjiRequest['+k+'].idMasterMataUji', formData.mata_ujian[k].idMasterMataUji);
            form.append('sertifikasiRplMataUjiRequest['+k+'].deskripsi', formData.mata_ujian[k].deskripsi);
            form.append('sertifikasiRplMataUjiRequest['+k+'].batasNilai', formData.mata_ujian[k].batasNilai);
        }
        form.append("kategori", formData.kategori);
        form.append("biayaPerMataUji", "0");
        form.append("status", formData.status);
        form.append("skpTerstruktur", formData.skpTerstruktur);
        form.append("skpNonTerstruktur", formData.skpNonTerstruktur);
        form.append("skpAssessment", formData.skpAssessment);

        return axios
            .post(
                API_URL + postRplCtaUrl,
                form,
                { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
            );
    }
    
    putRplCTA(formData) {
        return axios
        .put(
            API_URL + putRplCtaUrl + formData.idSertifikasiRpl,
            formData,
            {
                headers: authHeader()
            }
        );
    }

    putRplCTABackup(formData) {
        var form = new FormData();
        form.append("kodeRpl", formData.kodeRpl);
        form.append("namaRpl", formData.namaRpl);
        form.append("idLevel", formData.idLevelAnggota);
        form.append("biaya", formData.hargaPendaftaran);
        form.append("biayaMengulang", formData.biayaMengulang);
        form.append("tanggalDimulai", formData.tanggalDimulai);
        form.append("tanggalBerakhir", formData.tanggalBerakhir);
        form.append("lokasi", formData.lokasi);
        form.append("idKotaKab", formData.idKotaKab);
        form.append("kapasitas", formData.kapasitas);
        form.append("sisa", formData.kapasitas);
        form.append("idKategoriRpl", "1bc7e9ee-b8b8-4c5a-972c-7fa0ecb75f6f");
        for (var i = 0; i < formData.instrukturSertifikasiRpl.length; i++) {
            form.append('instrukturSertifikasiRplRequest['+i+'].idInstrukturRpl', formData.instrukturSertifikasiRpl[i].idInstrukturRpl);
            form.append('instrukturSertifikasiRplRequest['+i+'].idRplSertifikasiRplInstruktur', formData.instrukturSertifikasiRpl[i].idInstrukturSertifikasiRpl);
        }
        for (var j = 0; j < formData.dokumenPendukungSertifikasiRpl.length; j++) {
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].kodeDokumen', formData.dokumenPendukungSertifikasiRpl[j].kodeDokumen);
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].namaDokumen', formData.dokumenPendukungSertifikasiRpl[j].namaDokumen);
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].idDokumenPendukungSertifikasiRpl', formData.dokumenPendukungSertifikasiRpl[j].idDokumenPendukungSertifikasiRpl);
            if (typeof formData.dokumenPendukungSertifikasiRpl[j].contohDokumen !== 'undefined') {
                form.append('dokumenPendukungSertifikasiRplRequest['+j+'].contohDokumen', formData.dokumenPendukungSertifikasiRpl[j].contohDokumen);
            }
        }
        for (var k = 0; k < formData.sertifikasiRplMataUji.length; k++) {
            form.append('sertifikasiRplMataUjiRequest['+k+'].idMasterMataUji', formData.sertifikasiRplMataUji[k].idMasterMataUji);
            form.append('sertifikasiRplMataUjiRequest['+k+'].deskripsi', formData.sertifikasiRplMataUji[k].deskripsi);
            form.append('sertifikasiRplMataUjiRequest['+k+'].batasNilai', formData.sertifikasiRplMataUji[k].nilaiMinimum);
            form.append('sertifikasiRplMataUjiRequest['+k+'].idSertifikasiRplMataUji', formData.sertifikasiRplMataUji[k].idSertifikasiRplMataUji);
        }
        form.append("kategori", formData.kategori);
        form.append("biayaPerMataUji", "0");
        form.append("status", formData.status);
        form.append("skpTerstruktur", formData.skpTerstruktur);
        form.append("skpNonTerstruktur", formData.skpNonTerstruktur);
        form.append("skpAssessment", formData.skpAssessment);
        return axios
            .put(
                API_URL + putRplCtaUrl + formData.idSertifikasiRpl, form,
                { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
            );
    }


    deleteRplCTA(formData) {
        return axios
            .delete(
                API_URL + deleteRplCTA + formData,
                { headers: authHeader() }
            );
    }

}

export default new RplCTAService();
